import React, { Dispatch, SetStateAction, SyntheticEvent } from 'react';

import '../../style.css';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import { isPossiblePhoneNumber } from 'libphonenumber-js';


type PhoneInputFormProps = {
  phoneNumber: string;
  setPhoneNumber: Dispatch<SetStateAction<string>>;
  handleSubmit: (event: SyntheticEvent) => Promise<void>;
  sendVerificationError: boolean;
}

export const PhoneInputForm = ({
  phoneNumber,
  setPhoneNumber,
  handleSubmit,
  sendVerificationError,
}: PhoneInputFormProps) => {

  const setCountryCode = (event: React.FocusEvent<HTMLInputElement, Element>) => {
    if (event.type === 'focus' && phoneNumber.length === 0) {
      setPhoneNumber('+1');
      const inputElement = document.getElementById('phone-number-input') as HTMLInputElement;
      inputElement.setSelectionRange(2,2);
    }
  };

  return (
    <div className='login-page-container'>
      <img
        width="300"
        height="150"
        src={require('assets/vlted_logo_transparent_black.png')}
        className="App-logo"
        alt="logo"
      />
      <form id="phone-number-input-form" onSubmit={handleSubmit}>
        <label>
          <p className="text">
            Phone Number:
          </p>
          <Input
            id='phone-number-input'
            accessibilityLabel='phone-number-input'
            value={phoneNumber}
            handleOnChange={setPhoneNumber}
            handleOnFocus={setCountryCode}
            error={sendVerificationError ? 'Something went wrong!' : undefined}
            icon='phone'
          />
        </label>
      </form>
      <Button
        accessibilityLabel='sign-in-button'
        type='primary'
        text='Send code'
        formName='phone-number-input-form'
        disabled={!isPossiblePhoneNumber(phoneNumber, 'US')}
      />
    </div>
  );
};
